<template>
    <!-- 팝업 -->
    <div class="pop_up_layer find_account" style="display: block" @click="closeModal"></div>
    <div class="pop_up pop_detail" id="find_account" style="display: block">
        <button class="close_btn" @click="closeModal">
            <img src="img/close.png" alt="닫기" />
        </button>

        <template style="display: block">
            <div class="pop_tit">
                <p>내담자 검색</p>
            </div>

            <div class="content_wrap">
                <ul>
                    <li>
                        <span>연번 검색</span>
                        <div style="position: relative">
                            <div>
                                <input type="text" placeholder="연번을 입력해주세요." v-model="state.number" v-on:keyup.enter="findClient" />
                                <button type="button" @click="findClient">검색</button>
                            </div>

                            <div class="select-wrap" style="" v-show="state.isSearch">
                                <select v-model="state.selectedItem" @change="isSelect2">
                                    <option
                                        :value="{ vstNo: item.number, clIdx: item.idx }"
                                        v-text="item.number"
                                        v-for="(item, key) in state.list"
                                        :key="key"
                                    ></option>
                                </select>
                            </div>
                        </div>
                    </li>

                    <li>
                        <span>프로그램 검색</span>
                        <div class="select-wrap">
                            <select v-model="state.group" @change="isSelect">
                                <!-- <option value="" >선택해주세요.</option> -->
                                <option v-for="item in state.listForGroup" :value="item" v-text="item.name"></option>
                            </select>
                        </div>
                    </li>
                </ul>

                <div class="btn_wrap">
                    <!-- <button class="submit_btn _gray" @click="closeModal">닫기</button> -->
                    <!-- <button class="submit_btn" @click="callbackFun">확인</button> -->
                </div>
            </div>
        </template>
    </div>
    <!-- 팝업 -->

    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        :idx="state.group.idx"
        :gubun="state.gubun"
        @close="state.isShowModal = false"
        @callback="callbackModal"
    ></ModalDefault>
</template>
<script lang="ts" config>
    import { reactive, onMounted, onUnmounted, types, apiService, ModalDefault, getMessageByCode, watch } from "@/BaseComponent";

    export default {
        props: {},
        emits: ["close", "callback", "callback2"],
        components: { ModalDefault },
        setup(props: any, { emit }: any) {
            const state = reactive({
                number: "" as string,
                list: [] as Array<types.client.ClientVOForApi>,
                group: {} as types.group.GroupVOForApi,
                listForGroup: [] as Array<types.group.GroupVOForApi | any>,

                isSearch: false as boolean,
                selectedItem: {} as any,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                gubun: 0 as number,
            });

            onMounted(() => {
                getListForGroup();

                document.body.style.overflow = "hidden";
            });

            onUnmounted(() => {
                document.body.style.overflow = "";
            });

            const closeModal = () => {
                emit("close");
            };

            const callbackFun = () => {
                if (state.group.idx || state.selectedItem.clIdx) {
                    emit("callback", state);
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "추가하고자 하는 연번 또는 프로그램을 검색해주세요.";
                    state.isShowModal = true;
                }
            };

            const callbackModal = (param: any) => {
                if (param.action === "confirm") {
                    if (param.gubun === 1) {
                        emit("callback", state.group.idx);
                    } else if (param.gubun === 2) {
                        emit("callback2", state.selectedItem);
                        state.isShowModal = false;
                    }
                } else if (param.action === "callback") {
                    state.isShowModal = false;
                }
            };

            const getListForGroup = async () => {
                const res = await apiService.group.listNoPaging();

                if (res.returnCode === 0) {
                    state.listForGroup = res.data;
                } else {
                    console.error(res.description);
                }
            };

            const findClient = async () => {
                if (state.number.length < 2) {
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = "연번을 최소 2글자 이상 입력해주세요.";
                    state.isShowModal = true;
                    return;
                }
                const res = await apiService.client.search(state.number);
                if (res.returnCode === 0 && res.data && res.data.length > 0) {
                    state.list = res.data;

                    state.isSearch = true;
                } else if (res.returnCode === 0) {
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = "검색된 결과가 없습니다.";
                    state.isShowModal = true;
                } else {
                    state.list = [];
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const isSelect = () => {
                state.modalTab = 1;
                state.modalTitle = "알림";
                state.modalContent = `정말 ${state.group.name}으로 선택하시겠습니까?`;
                state.isShowModal = true;
                state.gubun = 1;
            };

            const isSelect2 = () => {
                state.modalTab = 1;
                state.modalTitle = "알림";
                state.modalContent = `정말 ${state.selectedItem.vstNo}으로 선택하시겠습니까?`;
                state.isShowModal = true;
                state.gubun = 2;
            };

            return { state, emit, closeModal, callbackModal, callbackFun, isSelect, isSelect2, findClient };
        },
    };
</script>

<style scoped>
    .content_wrap {
        margin-top: 20px;
    }
    .content_wrap ul li {
        display: flex;
        margin-bottom: 20px;
        align-items: center;
    }
    .content_wrap ul li > span {
        min-width: 120px;
        margin-right: 20px;
        text-align: right;
    }

    .content_wrap ul li > div > div:not(.select-wrap) {
        display: flex;
        width: 100%;
    }

    .content_wrap ul li > div > div > input {
        display: block;
        width: calc(100% - 80px);

        font-family: Noto Sans KR;
        font-weight: 400;
        font-style: Regular;
        font-size: 16px;

        line-height: 100%;
        letter-spacing: 0%;
        text-align: left;
    }

    .content_wrap ul li div div.select-wrap {
        z-index: 9;
    }
</style>
